import Container from "react-bootstrap/Container";
import { allSportsPath, liveBoardPath } from "../../constants/routes";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LIVE_SECTION_LABEL } from "../../utility/siteCopy";
import WebsiteBrandLogo from "../common/WebsiteBrandLogo";

function HomeHeader() {
  const [active, setActive] = useState(null);
  const accountData = useSelector((state) => state.auth);
  const isAuth = Boolean(accountData?.isAuth);

  useEffect(() => {
    const scrollActive = () => {
      setActive(window.scrollY > 20);
    };
    window.addEventListener("scroll", scrollActive);
    return () => window.removeEventListener("scroll", scrollActive);
  }, [active]);
  return (
    <Navbar
      expand="xl"
      className={`${active ? "header_nav active" : "header_nav"} `}>
      <Container className="custom_container">
        {/* Phone / tablet: logo + Login/Sign up in the top row (client chrome). */}
        <div className="d-xl-none hh_mob_bar w-100">
          <Navbar.Brand className="p-0 hh_mob_brand">
            <WebsiteBrandLogo linkTo="/" />
          </Navbar.Brand>
          <div className="hh_mob_actions">
            {!isAuth ? (
              <div className="hh_mob_auth">
                <Link to="/login" className="img_btn img_btn_fw loginBtn hh_mob_auth__btn">
                  Login
                </Link>
                <Link to="/signup" className="img_grd_btn img_btn_fw loginBtn hh_mob_auth__btn">
                  Sign Up
                </Link>
              </div>
            ) : null}
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="hh_mob_toggle"
            />
          </div>
        </div>

        <Navbar.Collapse id="basic-navbar-nav" className="d-xl-none">
          <Nav className="d-xl-none">
            <Nav className="hh_mob_nav">
              <NavLink to="/">Home</NavLink>
              {isAuth && (
                <>
                  <NavLink to={allSportsPath()}>Dashboard</NavLink>
                  <NavLink to={liveBoardPath()}>{LIVE_SECTION_LABEL}</NavLink>
                </>
              )}
              <NavLink to="/faq">Faq</NavLink>
              <NavLink to="/contact_us">Contact Us</NavLink>
            </Nav>
          </Nav>
        </Navbar.Collapse>

        {/* Desktop */}
        <div className="d-none d-xl-flex justify-content-between align-items-center w-100">
          <Navbar.Brand href="/">
            <WebsiteBrandLogo linkTo="/" />
          </Navbar.Brand>
          <Nav className="hh_nav">
            <NavLink to="/">Home</NavLink>
            {isAuth && (
              <>
                <NavLink to={allSportsPath()}>Dashboard</NavLink>
                <NavLink to={liveBoardPath()}>{LIVE_SECTION_LABEL}</NavLink>
              </>
            )}
            <NavLink to="/faq">Faq</NavLink>
            <NavLink to="/contact_us">Contact Us</NavLink>
          </Nav>

          {!isAuth ? (
            <div className="d-flex align-items-center gap-3">
              <Link to="/login">
                <button type="button" className="img_btn img_btn_fw loginBtn">Login Now</button>
              </Link>
              <Link to="/signup">
                <button type="button" className="img_grd_btn img_btn_fw loginBtn">Sign Up</button>
              </Link>
            </div>
          ) : null}
        </div>
      </Container>
    </Navbar>
  );
}

export default HomeHeader;
